import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import ShiftEntity from "../../entities/ShiftEntity";
import ShiftRepository from "../../repositories/ShiftRepository";
interface _Props {
    shiftRepository: ShiftRepository;
}

@injectable()
export default class CreateShiftWithScheduleUseCase {
    private shiftRepository: ShiftRepository;

    constructor(props: _Props) {
        this.shiftRepository = props.shiftRepository;
    }

    public call = async (_: {
        scheduleId: string;
        date: Date;
        userId: string;
    }): Promise<Either<ErrorEntity, ShiftEntity>> => {
        return await this.shiftRepository.createShiftWithSchedule(_);
    }
}

export const CreateShiftWithScheduleUseCaseName = "CreateShiftWithScheduleUseCase";